import { ImsStatus } from "@redotech/crdb-enums/inventory/ims-status";
import { useRequiredContext } from "@redotech/react-util/context";
import { isWmsSotEnabledForAnyLocation } from "@redotech/redo-fulfillment-wms-common/wms-constants";
import { TeamContext } from "@redotech/redo-web/context/team-context";

interface CycleCountTeam {
  settings: {
    ims?: { enabled: boolean; status: ImsStatus | null } | null;
    outboundLabels?: {
      wms?: { sourceOfTruthEnabled?: boolean | null } | null;
    } | null;
  };
}

/**
 * Cycle counts only apply where Redo owns on hand: IMS source of truth, or
 * WMS source of truth at some location. Matches `ownsOnHandAtLocation`.
 */
export function teamCanCycleCount(team: CycleCountTeam): boolean {
  const ims = team.settings.ims;
  const imsSourceOfTruth =
    !!ims?.enabled && ims.status === ImsStatus.SourceOfTruth;
  return (
    imsSourceOfTruth ||
    isWmsSotEnabledForAnyLocation(team.settings.outboundLabels?.wms)
  );
}

export function useTeamCanCycleCount(): boolean {
  return teamCanCycleCount(useRequiredContext(TeamContext));
}
